var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",staticClass:"form-item-repeater-item"},[_vm._t("default",null,null,{ item: _vm.item }),_vm._t("buttons",function(){return [_c('base-button',{attrs:{"label":_vm.$t('common.term.delete'),"color":"negative","outline":""},on:{"click":function($event){return _vm.item.remove()}}})]},null,{ item: _vm.item })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }